import React, { FunctionComponent, useEffect } from 'react'

import { useIntercom } from 'react-use-intercom'

import { Spinner } from '@fairhq/common'
import { useAuthContext } from 'auth/context/useAuthContext'
import { useGetApiHeaderData } from 'hooks/useGetApiHeaderData'
import LoggedInApp from 'LoggedInApp'
import { apiHeadersActions } from 'store/apiHeaders/apiHeadersSlice'
import { authActions } from 'store/auth/authSlice'
import { companyActions } from 'store/company/companySlice'
import { useAppDispatch } from 'store/hooks'
import { convertToIntercomUser } from 'utils/convertToIntercomUser'
import { redirectToCharlie } from 'utils/redirectToCharlie'

const AppContent: FunctionComponent = () => {
  const dispatch = useAppDispatch()
  const { update: updateIntercom } = useIntercom()

  const { isAuthenticated, isLoading, user, charlieUser } = useAuthContext()

  const hasData = useGetApiHeaderData(isAuthenticated)

  const { jwt } = useAuthContext()

  // At this level, the token should be present.
  // If not, user needs to proper login again so redirect to Charlie
  useEffect(() => {
    if (!jwt) {
      redirectToCharlie()
    }
  }, [jwt])

  useEffect(() => {
    if (jwt && user && charlieUser) {
      dispatch(authActions.setUser({ user, charlieUser }))
      dispatch(apiHeadersActions.setCompanyId(user.companyId))
      dispatch(apiHeadersActions.setAccountId(user.accountId))
      dispatch(apiHeadersActions.setSessionId(user.sessionId))
      dispatch(companyActions.setSessionCurrentlyViewing(user.sessionId))

      updateIntercom(convertToIntercomUser(user))
    }
  }, [jwt, dispatch, user, charlieUser, updateIntercom])

  if ((isAuthenticated === true && hasData === false) || isLoading) {
    return <Spinner center />
  }
  return <LoggedInApp />
}

export default React.memo(AppContent)
